<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:zipFlag="zipFlag"
		:pagingFlag="pagingFlag"
		:exportByServerFlag="exportByServerFlag"
		:getFiltersParams="getFiltersParams"
		:reportFormUrl="reportFormUrl"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'>
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/balance.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapBest.vue'
import FiltersBox from '@/components/reportform/balance/FiltersBox.vue'
export default {
	name: 'balance',
	components: {
		reportFormWrap,
		FiltersBox
	},
	data () {
		return {
			zipFlag: false, // 是否压缩
			pagingFlag: false, // 是否真分页
			exportByServerFlag: false, // 是否后端导出
			reportid: 'REPORT_YEDZ_000001',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/prepaymentCycleSummaryReport`,
			orderMenu: orderMenu,
			reportName: 'balance'
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
